import React from 'react';
import "./AthenaLogo.css";

const AthenaLogo = class extends React.Component {
	render() {
		return (
			<svg stroke="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style={this.props.style || {}} className={"AthenaLogoSvg"}>
				<path className="spear"
					  d="M27.9,1.09s-2.87,2.03-3.94,3.88-.43,2.21-.43,2.21l-13.32,23.08,1.27.74L24.8,7.92s.63.37,1.7-1.48,1.39-5.35,1.39-5.35Z"/>
				<path className="shield"
					  d="M10.2,1C5.12,1,1,5.12,1,10.2s4.12,9.2,9.2,9.2,9.2-4.12,9.2-9.2S15.29,1,10.2,1ZM10.2,17.57c-4.07,0-7.36-3.3-7.36-7.36s3.3-7.36,7.36-7.36,7.36,3.3,7.36,7.36-3.3,7.36-7.36,7.36ZM14.5,10.2c0,2.37-1.92,4.3-4.3,4.3s-4.3-1.92-4.3-4.3,1.92-4.3,4.3-4.3,4.3,1.92,4.3,4.3Z"/>
				<path className="athena" d="M28.06,10.2v.04l-.05-.03-12,20.79,2.36-.08,3.82-6.61h5.88v6.65h2V10.2h-2ZM23.33,22.31l4.73-8.19v8.19h-4.73Z"/>
			</svg>
		);
	}
}

export default AthenaLogo;